var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters } from "vuex";
import BasicArcheivesService from '../../api/BasicArcheivesService';
import { Loading } from 'element-ui';
import AddAndEditStoreSplit from './component/AddAndEditStoreSplit.vue';
import TableHeaderToolTip from './component/TableHeaderToolTipNew.vue';
import BusinessGoodsPriceService from '../../api/BusinessGoodsPriceService';
import { tidyDataBusinessInfo } from '../../helper/newBusinessGoodsPriceFunc';
var StoreSplit = (function (_super) {
    __extends(StoreSplit, _super);
    function StoreSplit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchParams = {
            status: '',
            search_type: '1',
            search: ''
        };
        _this.statusOptions = [
            { value: '', label: '全部' },
            { value: '1', label: '启用' },
            { value: '2', label: '禁用' }
        ];
        _this.searchTypeOptions = [
            { value: '1', label: '客户名称' },
            { value: '2', label: '门店名称' },
            { value: '3', label: '服务区域' }
        ];
        _this.selectRows = [];
        _this.tableHeight = 300;
        return _this;
    }
    StoreSplit.prototype.created = function () {
        var _this = this;
        console.log('this.Root_PageAuth', this.Root_PageAuth);
        console.log('this.openedCodeData', this.openedCodeData);
        this.service = BasicArcheivesService.getInstance();
        this.businessService = BusinessGoodsPriceService.getInstance();
        this.getOrganList().then(function () {
            _this.getStoreSplitList();
        });
    };
    StoreSplit.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 211;
        }, 300);
    };
    StoreSplit.prototype.delStoreSplit = function (data) {
        var _this = this;
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426\u5220\u9664\u8BE5\u914D\u9001\u89C4\u5219\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
            center: true,
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.delStoreSplit({
                    rule_id: data.rule_id
                }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success("\u5220\u9664\u6210\u529F");
                        _this.getStoreSplitList(_this.pager);
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                    loadingInstance_1.close();
                }, function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                });
            }
        }).catch(function () { });
    };
    StoreSplit.prototype.changeStatus = function (data) {
        var _this = this;
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426" + (data.status == 1 ? '启用' : '禁用') + "\u8BE5\u914D\u9001\u89C4\u5219\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
            center: true,
        }).then(function (res) {
            if (res) {
                var loadingInstance_2 = Loading.service({ fullscreen: true });
                _this.service.changeStoreSplitStatus({
                    rule_id: data.rule_id,
                    status: data.status
                }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success("\u4FEE\u6539\u6210\u529F");
                        _this.getStoreSplitList(_this.pager);
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                    loadingInstance_2.close();
                }, function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_2.close();
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_2.close();
                });
            }
        }, function (err) {
            _this.$message.error(err.message);
            if (data.status == 1) {
                data.status = 2;
            }
            else {
                data.status = 1;
            }
        }).catch(function () { });
    };
    StoreSplit.prototype.getStoreSplitList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.pager = pager;
        var params = { from_system: 1 };
        if (this.searchParams.status) {
            params.status = this.searchParams.status;
        }
        if (this.searchParams.search && this.searchParams.search_type) {
            params.search_type = this.searchParams.search_type;
            params.search = this.searchParams.search;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getStoreSplitList(params).then(function (res) {
            var data = res.data.data;
            _this.listData = data || [];
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreSplit.prototype.pageChange = function (pager) {
        this.getStoreSplitList(pager);
    };
    StoreSplit.prototype.getOrganList = function () {
        var _this = this;
        return this.service.getOrganList().then(function (res) {
            var data = res.data.data;
            _this.organList = data || [];
        });
    };
    StoreSplit.prototype.addStore = function () {
        var _this = this;
        var instance = this.$dialog(AddAndEditStoreSplit, {
            data: {
                organList: this.organList
            }
        }, {
            title: "新增配送规则",
            width: 560,
            height: 400
        }).instance;
        instance.$on("addClient:ok", function (data) {
            _this.getStoreSplitList();
        });
    };
    StoreSplit.prototype.editStore = function (item) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        return this.service.getStoreSplitDetail({
            rule_id: item.rule_id
        }).then(function (res) {
            loadingInstance.close();
            if (!res.data.success) {
                _this.$message.error(res.data.msg);
                return;
            }
            ;
            var data = res.data.data;
            var params = {
                is_have_empty_group: 1,
                is_have_shop: 1
            };
            _this.businessService.getClientsByGroupTree(params).then(function (res2) {
                var cgTree = res2.data.data || [];
                var supplier_to_business_ids = data.supplier_to_business_id || [];
                var shop_supplier_to_business_ids = (data.shop_id || []).map(function (shop) {
                    return shop.shop_id + '_' + shop.supplier_to_business_id + '_' + shop.business_id;
                });
                var tmp_supplier_to_business_ids = supplier_to_business_ids.concat(shop_supplier_to_business_ids);
                var res3 = tidyDataBusinessInfo(cgTree, tmp_supplier_to_business_ids, data.group_id, data.shop_id, data.business_id);
                data.business_info = res3.business_info;
                data.business_info_name = res3.business_info_name;
                data.supplier_to_business_id = res3.supplier_to_business_ids;
                var instance = _this.$dialog(AddAndEditStoreSplit, {
                    data: {
                        storeEditInfo: data,
                        organList: _this.organList
                    }
                }, {
                    title: "\u4FEE\u6539" + res.data.data.rule_name + "\u914D\u9001\u89C4\u5219",
                    width: 560,
                    height: 400
                }).instance;
                instance.$on("addClient:ok", function () {
                    _this.getStoreSplitList(_this.pager);
                });
                _this.getFilterData({
                    rule_id: item.rule_id,
                    from_system: 1,
                    depot_id: data.depot_id,
                });
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreSplit.prototype.getFilterData = function (params) {
        return this.service.getStoreSplitFilterData(params).then(function (res) {
            console.log('extra_selected_goods', res.data.data.extra_selected_goods);
            console.log('extra_selected_goods_type', res.data.data.extra_selected_goods_type);
        });
    };
    StoreSplit.prototype.getStoreSplitDetail = function (item) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        return this.service.getStoreSplitDetail({
            rule_id: item.rule_id
        }).then(function (res) {
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreSplit.prototype.search = function () {
        this.getStoreSplitList({ page: 1, start: 0, limit: 20 });
    };
    StoreSplit = __decorate([
        Component({
            components: {
                TableHeaderToolTip: TableHeaderToolTip
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
            })),
            methods: __assign({}, mapActions(["getAuth"]), { renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "采购数量*采购系数+库存数量",
                            placement: "bottom"
                        }
                    }, '机构默认库');
                },
                renderHeaderRuleTip: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "提示：<br/>1.配送规则设置仓库可以服务哪些门店（例如“石家庄A仓库服务河南的门店”）<br/>2.配送规则的不可重复性：<br/>（1）不同配送中心已启用的且相同优先级的配送规则，客户分组、客户及门店不能重复；<br/>（2）同一配送中心已启用的规则，客户分组、客户及门店不能重复；<br/>（3）客户选择列表：不在服务区域内的客户及门店无法选择、配送中心已配置过且已启用规则里包含的客户分组及门店无法选择；<br/>3.选择服务客户时，可选择 按客户分组、按客户维度设置，即该分组、该客户下后续新增的门店若在该服务区域内，则将客户门店默认添加到该规则内；<br/>4.外销商城下单货品，需要至少有一个配送中心服务该门店；<br/>5.校验库存时，根据配送规则确认配送中心时，优先取高优先级的配送规则，若高优先级的配送规则的仓库仓库无库存，则降低优先级，取次优先级有库存的出库仓库。",
                            placement: 'bottom',
                        },
                    }, '操作');
                } })
        })
    ], StoreSplit);
    return StoreSplit;
}(Vue));
export default StoreSplit;
